import { orderConfirmationBillingInformationStyles as styles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { commonHeading } from "@solveindustrial/WidgetExtensions/Components/SmallHeadingAndTextExtension";
import { css } from "styled-components";

styles.billingInformationTitle = {
    ...styles.billingInformationTitle,
    variant: "h4",
    css: css`
        ${styles.billingInformationTitle?.css}
        width: 100%;
        margin: 0 0 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
    `,
};

styles.billingAddressTitle = {
    ...styles.billingAddressTitle,
    ...commonHeading,
};
styles.billingCreditCardAddressTitle = {
    ...styles.billingCreditCardAddressTitle,
    ...commonHeading,
};
